import {gql} from "@apollo/client";

export const sendConversationMessageMutation = gql`
    mutation SendConversationMessage($messageDto: MessageDto!) {
        sendConversationMessage(messageDto: $messageDto) {
            id
            text
            created
            resolved
            sender {
                id
            }
            deleted
            isSenderBlocked
            richContent {
                systemMessages {
                    message
                }
            }
        }
    }
`;
